import { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import TextInput from "../../components/Form/TextInput";
import { DatePicker, InputNumber } from "antd";
import dayjs from "dayjs";
import RadioInput from "../../components/Form/Radio/RadioInput";
import { ReactComponent as Arrow } from "../../images/v-arrow.svg";
import FileUpload from "../../components/FileUpload/FileUploadWithThumb";
import axios from "../../axios/axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setFloorAppFormDeatils } from "../../redux/slice/newFloorApplication";
import moment from "moment";
import { ConvertByteToMb, IMAGE_BASE_URL } from "../../common/Constants";

const VehicleDetailsBodyOnly = ({
  selectedOption,
  formValues,
  onSubmit,
  methods,
  ApplicationId,
  setIsStepCompleted,
  isStepCompleted,
}) => {
  const dispatch = useDispatch();
  const [showUploadDocument, setShowUploadDocument] = useState(true);
  const [isShowVehicleDetails, setisShowVehicleDetails] = useState(true);
  const [showUsedVehicle, setShowUsedVehicle] = useState(true);
  const [UploadDocuments, setUploadDocuments] = useState({
    v5_overseas_logcard: [],
    sales_agreement: [],
    data_card: [],
    cargo_clearance_permit: [],
    bill_of_landing: [],
    letter_of_newness: [],
    additional: [],
  });
  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    watch,
    getValues,
    setValue,
    reset,
  } = methods;

  useEffect(() => {
    reset(formValues);
  }, [formValues]);

  const CustomFileUpload = async (file, onSuccess, onError, formValue) => {
    if (ConvertByteToMb(file.size) <= 5) {

      const formData = new FormData();
      formData.append("file[]", file);
      formData.append("module", "flooring");
      try {
        const response = await axios
          .post("/flooring/document", formData)
          .then((resp) => {
            setValue(
              `${formValue}`,
              getValues(`${formValue}`)?.concat(resp.data?.data)
            );
            onSuccess();
          });
      } catch (error) {
        onError(error);
      }
    }
  };

  const SubmitIncompleteForm = async (data) => {
    const dataObj = {
      vehicleInfo: {
        ...data,
        is_step1_valid: 0,
        is_draft: 1,
        flooring_product: selectedOption,
        original_reg_date:
          watch("original_reg_date") !== "" && watch("orignal_reg_date")
            ? moment(watch("original_reg_date"))?.format("DD-MM-YYYY")
            : "",
      },
      v5_overseas_logcard: data?.v5_overseas_logcard,
      sales_agreement: data?.sales_agreement,
      data_card: data?.data_card,
      cargo_clearance_permit: data?.cargo_clearance_permit,
      bill_of_landing: data?.bill_of_landing,
      letter_of_newness: data?.letter_of_newness,
      additional: data?.additional,
    };
    const resp = await axios.post(
      `flooring/application/update/${ApplicationId}`,
      dataObj
    );
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      setIsStepCompleted({
        ...isStepCompleted,
        1: false,
      });
      dispatch(
        setFloorAppFormDeatils({
          isStepCompleted: {
            ...isStepCompleted,
            1: false,
          },
          vehicleInfo: getValues(),
        })
      );
    }
  };
  const tempSubmit = (Err) => {
    if (
      Object.values(getValues())?.filter((it) => it !== "" && it !== null)
        ?.length >= Number(`${watch("is_VAC_ready") == 1 ? 19 : 18}`) &&
      getValues("v5_overseas_logcard")?.length > 0 &&
      getValues("sales_agreement")?.length > 0 &&
      getValues("bill_of_landing")?.length > 0 &&
      getValues("cargo_clearance_permit")?.length > 0 &&
      getValues("data_card")?.length > 0 &&
      getValues("letter_of_newness")?.length > 0
    ) {
      onSubmit(getValues());
    } else {
      SubmitIncompleteForm(getValues());
    }
  };

  const GetFilesFormatted = (files) => {
    return files?.length > 0
      ? files?.map((url, idx) => {
        return {
          uid: idx + 1,
          name: url.name ? url.name : "Document",
          status: "done",
          url: `${IMAGE_BASE_URL}${url.path}`,
        };
      })
      : [];
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(tempSubmit)}>
        <div className="clear-menu-block">
          <div
            onClick={() => setShowUsedVehicle(!showUsedVehicle)}
            className="arrow-icon-block"
          >
            <span className={`${showUsedVehicle ? null : "down-arrow"}`}>
              <Arrow />
            </span>
            {selectedOption} (Unregistered New or Imported Used Vehicles)
          </div>
          <span
            className="clear-menu"
            onClick={() => {
              console.log("Click clear");
            }}
          >
            Clear
          </span>
        </div>
        {showUsedVehicle ? (
          <>
            <div className="input-one-line">
              <Controller
                name="make_model"
                control={control}
                rules={{
                  required: "Make/Model is required",
                }}
                render={({ field, fieldState }) => (
                  <TextInput
                    label="Make/Model"
                    type="text"
                    name={field.name}
                    error={fieldState?.invalid ? "error" : null}
                    placeholder="Enter a Make/Model"
                    onChange={(e) => field.onChange(e.target.value)}
                    value={field.value}
                    register={register}
                    className="w-full md:max-w-[650px]"
                  />
                )}
              />
              <Controller
                name="yom"
                control={control}
                rules={{
                  required: "Chassis no is required",
                }}
                render={({ field, fieldState }) => (
                  <TextInput
                    label="Y.O.M"
                    type="text"
                    name={field.name}
                    error={fieldState?.invalid ? "error" : null}
                    placeholder="2018"
                    onChange={(e) => field.onChange(e.target.value)}
                    value={field.value}
                    register={register}
                    className="w-[60px]"
                  />
                )}
              />
            </div>
            <div className="input-one-line">
              <Controller
                control={control}
                name="purchase_price"
                rules={{
                  required: true,
                }}
                render={({ field, fieldState }) => {
                  return (
                    <div className="input-group w-full md:max-w-[310px] lg:max-w-[355px]">
                      <label>Purchase Price</label>
                      <InputNumber
                        type="number"
                        prefix="$"
                        name={field.name}
                        ref={field.ref}
                        value={field.value}
                        status={fieldState?.invalid ? "error" : null}
                        prefixCls="sign_Icon"
                        placeholder="0.00"
                        precision={2}
                        step="0.01"
                        className="!w-full cusAdmInputNumber2"
                        onChange={(val) => field.onChange(val)}
                      />
                    </div>
                  );
                }}
              />
              <Controller
                control={control}
                name="intended_floor_amount"
                rules={{
                  required: true,
                }}
                render={({ field, fieldState }) => {
                  return (
                    <div className="input-group w-full md:max-w-[310px] lg:max-w-[355px]">
                      <label>Intended Floor Amount</label>
                      <InputNumber
                        type="number"
                        prefix="$"
                        name={field.name}
                        ref={field.ref}
                        value={field.value}
                        status={fieldState?.invalid ? "error" : null}
                        prefixCls="sign_Icon"
                        placeholder="0.00"
                        precision={2}
                        step="0.01"
                        className="!w-full cusAdmInputNumber2"
                        onChange={(val) => field.onChange(val)}
                      />
                    </div>
                  );
                }}
              />
            </div>

            <div className="input-one-line">
              <Controller
                control={control}
                name="original_reg_date"
                rules={{
                  required: true,
                }}
                render={({ field, fieldState }) => {
                  return (
                    <div className="input-group">
                      <label>Original Reg Date (Overseas)</label>
                      <DatePicker
                        placeholder="DD-MM-YYYY"
                        status={fieldState?.invalid ? "error" : null}
                        name={field.name}
                        ref={field.ref}
                        format={"DD-MM-YYYY"}
                        className={`py-[8px] w-full md:w-[230px]`}
                        value={
                          field.value !== undefined && field.value !== "" && field.value !== null
                            ? dayjs(field.value).isValid()
                              ? dayjs(field.value)
                              : typeof field.value === "number" ? field.value : dayjs(field.value.split("-").reverse().join("-"))

                            : null
                        }
                        onChange={(date) => {
                          field.onChange(date !== null ? date.valueOf() : "");
                        }}
                      />
                    </div>
                  );
                }}
              />
              <Controller
                name="engine_no"
                control={control}
                rules={{
                  required: "Engine no is required",
                }}
                render={({ field, fieldState }) => (
                  <TextInput
                    label="Engine No."
                    type="text"
                    name={field.name}
                    error={fieldState?.invalid ? "error" : null}
                    placeholder="Enter a engine no"
                    onChange={(e) => field.onChange(e.target.value)}
                    value={field.value}
                    register={register}
                    className="w-full md:w-[230px]"
                  />
                )}
              />
              <Controller
                name="chassis_no"
                control={control}
                rules={{
                  required: "Chassis no is required",
                }}
                render={({ field, fieldState }) => (
                  <TextInput
                    label="Chassis No."
                    type="text"
                    name={field.name}
                    error={fieldState?.invalid ? "error" : null}
                    placeholder="Enter a chassis no"
                    onChange={(e) => field.onChange(e.target.value)}
                    value={field.value}
                    register={register}
                    className="w-full md:w-[230px]"
                  />
                )}
              />
            </div>
            <div className="input-one-line">
              <div className="radio-input-block">
                <label className="heading-label">Vehicle Status</label>
                <Controller
                  name="vehicle_status"
                  control={control}
                  rules={{
                    required: "Please Select an option",
                  }}
                  render={({ field, fieldState }) => (
                    <div className="radio-input-list">
                      <RadioInput
                        value="0"
                        name={`vehicle_status`}
                        checked={watch("vehicle_status") == 0}
                        onChange={(e) => {
                          setValue("vehicle_status", 0);
                        }}
                        label="Brand New"
                      />
                      <RadioInput
                        name={`vehicle_status`}
                        checked={watch("vehicle_status") == 1}
                        onChange={(e) => {
                          setValue("vehicle_status", 1);
                        }}
                        value="1"
                        label="Import Used"
                      />
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="clear-menu-block">
              <div
                onClick={() => setisShowVehicleDetails(!isShowVehicleDetails)}
                className="arrow-icon-block"
              >
                <span
                  className={`${isShowVehicleDetails ? null : "down-arrow"}`}
                >
                  <Arrow />
                </span>
                Vehicle Details
              </div>
              <span
                className="clear-menu"
                onClick={() => {
                  console.log("Click clear");
                }}
              >
                Clear
              </span>
            </div>
            {isShowVehicleDetails ? (
              <>
                <div className="input-one-line">
                  <div className="radio-input-block">
                    <label className="heading-label">
                      Is your Vehicle VAC ready?
                    </label>
                    <Controller
                      name="is_VAC_ready"
                      control={control}
                      rules={{
                        required: "Please Select an option",
                      }}
                      render={({ field, fieldState }) => (
                        <div className="radio-input-list">
                          <RadioInput
                            value="0"
                            name={`is_VAC_ready`}
                            checked={watch("is_VAC_ready") == 0}
                            onChange={(e) => {
                              setValue("is_VAC_ready", 0);
                            }}
                            label="No"
                          />
                          <RadioInput
                            value="1"
                            name={`is_VAC_ready`}
                            checked={watch("is_VAC_ready") == 1}
                            onChange={(e) => {
                              setValue("is_VAC_ready", 1);
                            }}
                            label="Yes"
                          />
                        </div>
                      )}
                    />
                  </div>
                </div>
                {watch("is_VAC_ready") == 1 && (
                  <div className="input-one-line">
                    <Controller
                      name="VAC_number"
                      control={control}
                      rules={{
                        required: watch("is_VAC_ready") == 1,
                      }}
                      render={({ field, fieldState }) => (
                        <TextInput
                          label="VAC Number"
                          type="text"
                          name={field.name}
                          error={fieldState?.invalid ? "error" : null}
                          placeholder="Enter a VAC number"
                          onChange={(e) => field.onChange(e.target.value)}
                          value={field.value}
                          register={register}
                          className="w-full md:w-[230px]"
                        />
                      )}
                    />
                  </div>
                )}
              </>
            ) : null}
          </>
        ) : null}
        <div className="clear-menu-block">
          <div
            onClick={() => setShowUploadDocument(!showUploadDocument)}
            className="arrow-icon-block"
          >
            <span className={`${showUploadDocument ? null : "down-arrow"}`}>
              <Arrow />
            </span>
            Upload Document(s)
          </div>
          <span
            className="clear-menu"
            onClick={() => {
              console.log("Click clear");
            }}
          >
            Clear
          </span>
        </div>
        {showUploadDocument ? (
          <>
            <div className="upload-document-section">
              <Controller
                name="v5_overseas_logcard"
                control={control}
                rules={{
                  required: "Please upload documents",
                }}
                render={({ field, fieldState }) => {
                  return (
                    <FileUpload
                      action="your_upload_action_url"
                      label="V5/Overseas Logcard"
                      maxCount={6}
                      files={
                        field.value?.length > 0
                          ? GetFilesFormatted(field.value)
                          : []
                      }
                      CustomFileUpload={({ file, onSuccess, onError }) => {
                        CustomFileUpload(
                          file,
                          onSuccess,
                          onError,
                          "v5_overseas_logcard"
                        );
                      }}
                      onFileUpload={(fileList) => {
                        setUploadDocuments({
                          ...UploadDocuments,
                          v5_overseas_logcard: fileList,
                        });
                      }}
                      onRemove={(file) => {
                        setValue(
                          "v5_overseas_logcard",
                          getValues("v5_overseas_logcard")?.filter(
                            (it) => it?.name !== file?.name
                          )
                        );
                      }}
                    />
                  );
                }}
              />
              <Controller
                name="sales_agreement"
                control={control}
                rules={{
                  required: "Please upload documents",
                }}
                render={({ field, fieldState }) => (
                  <FileUpload
                    action="your_upload_action_url"
                    label="Sales Agreement"
                    maxCount={6}
                    files={
                      field.value?.length > 0
                        ? GetFilesFormatted(field.value)
                        : []
                    }
                    CustomFileUpload={({ file, onSuccess, onError }) => {
                      CustomFileUpload(
                        file,
                        onSuccess,
                        onError,
                        "sales_agreement"
                      );
                    }}
                    onFileUpload={(fileList) => {
                      setUploadDocuments({
                        ...UploadDocuments,
                        sales_agreement: fileList,
                      });
                    }}
                    onRemove={(file) => {
                      setValue(
                        "sales_agreement",
                        getValues("sales_agreement")?.filter(
                          (it) => it?.name !== file?.name
                        )
                      );
                    }}
                  />
                )}
              />
              <Controller
                name="data_card"
                control={control}
                rules={{
                  required: "Please upload documents",
                }}
                render={({ field, fieldState }) => (
                  <FileUpload
                    action="your_upload_action_url"
                    label="Data Card"
                    maxCount={6}
                    files={
                      field.value?.length > 0
                        ? GetFilesFormatted(field.value)
                        : []
                    }
                    CustomFileUpload={({ file, onSuccess, onError }) => {
                      CustomFileUpload(file, onSuccess, onError, "data_card");
                    }}
                    onFileUpload={(fileList) => {
                      setUploadDocuments({
                        ...UploadDocuments,
                        data_card: fileList,
                      });
                    }}
                    onRemove={(file) => {
                      setValue(
                        "data_card",
                        getValues("data_card")?.filter(
                          (it) => it?.name !== file?.name
                        )
                      );
                    }}
                  />
                )}
              />
              <Controller
                name="cargo_clearance_permit"
                control={control}
                rules={{
                  required: "Please upload documents",
                }}
                render={({ field, fieldState }) => (
                  <FileUpload
                    action="your_upload_action_url"
                    label="Cargo Clearance Permit"
                    maxCount={6}
                    files={
                      field.value?.length > 0
                        ? GetFilesFormatted(field.value)
                        : []
                    }
                    CustomFileUpload={({ file, onSuccess, onError }) => {
                      CustomFileUpload(
                        file,
                        onSuccess,
                        onError,
                        "cargo_clearance_permit"
                      );
                    }}
                    onFileUpload={(fileList) => {
                      setUploadDocuments({
                        ...UploadDocuments,
                        cargo_clearance_permit: fileList,
                      });
                    }}
                    onRemove={(file) => {
                      setValue(
                        "cargo_clearance_permit",
                        getValues("cargo_clearance_permit")?.filter(
                          (it) => it?.name !== file?.name
                        )
                      );
                    }}
                  />
                )}
              />
            </div>
            <div className="upload-document-section">
              <Controller
                name="bill_of_landing"
                control={control}
                rules={{
                  required: "Please upload documents",
                }}
                render={({ field, fieldState }) => (
                  <FileUpload
                    action="your_upload_action_url"
                    label="Bill of Landing (BL)"
                    maxCount={6}
                    files={
                      field.value?.length > 0
                        ? GetFilesFormatted(field.value)
                        : []
                    }
                    CustomFileUpload={({ file, onSuccess, onError }) => {
                      CustomFileUpload(
                        file,
                        onSuccess,
                        onError,
                        "bill_of_landing"
                      );
                    }}
                    onFileUpload={(fileList) => {
                      setUploadDocuments({
                        ...UploadDocuments,
                        bill_of_landing: fileList,
                      });
                    }}
                    onRemove={(file) => {
                      setValue(
                        "bill_of_landing",
                        getValues("bill_of_landing")?.filter(
                          (it) => it?.name !== file?.name
                        )
                      );
                    }}
                  />
                )}
              />
              <Controller
                name="letter_of_newness"
                control={control}
                rules={{
                  required: "Please upload documents",
                }}
                render={({ field, fieldState }) => (
                  <FileUpload
                    action="your_upload_action_url"
                    label="Letter of Newness"
                    maxCount={6}
                    files={
                      field.value?.length > 0
                        ? GetFilesFormatted(field.value)
                        : []
                    }
                    CustomFileUpload={({ file, onSuccess, onError }) => {
                      CustomFileUpload(
                        file,
                        onSuccess,
                        onError,
                        "letter_of_newness"
                      );
                    }}
                    onFileUpload={(fileList) => {
                      setUploadDocuments({
                        ...UploadDocuments,
                        letter_of_newness: fileList,
                      });
                    }}
                    onRemove={(file) => {
                      setValue(
                        "letter_of_newness",
                        getValues("letter_of_newness")?.filter(
                          (it) => it?.name !== file?.name
                        )
                      );
                    }}
                  />
                )}
              />
              <Controller
                name="additional"
                control={control}
                rules={{
                  required: false,
                }}
                render={({ field, fieldState }) => (
                  <FileUpload
                    action="your_upload_action_url"
                    label="Additional Document(s)"
                    maxCount={2}
                    files={
                      field.value?.length > 0
                        ? GetFilesFormatted(field.value)
                        : []
                    }
                    CustomFileUpload={({ file, onSuccess, onError }) => {
                      CustomFileUpload(file, onSuccess, onError, "additional");
                    }}
                    onFileUpload={(fileList) => {
                      setUploadDocuments({
                        ...UploadDocuments,
                        additional: fileList,
                      });
                    }}
                    onRemove={(file) => {
                      setValue(
                        "additional",
                        getValues("additional")?.filter(
                          (it) => it?.name !== file?.name
                        )
                      );
                    }}
                  />
                )}
              />
            </div>
          </>
        ) : null}

        <button
          className="sav_btn"
          type="submit"
          onClick={() => {
            if (
              Object.entries(getValues()).filter(
                ([key, value]) =>
                  value !== "" && value !== null && value.length > 0
              )?.length < Number(`${watch("is_VAC_ready") == 1 ? 17 : 16}`)
            ) {
              tempSubmit();
            }
          }}
        >
          Save
        </button>
      </form>
    </FormProvider>
  );
};

export default VehicleDetailsBodyOnly;
